import styled from 'styled-components';

export const MainContent = styled.div`
  height: 100%;
  max-width: 700px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
`;
